export default __webpack_public_path__ + "static/VarsityImage-3d45d63c406fa39165338a4a25de89b9.png";